"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proxyTypes = void 0;
exports.proxyTypes = [
    'CenturyGenerali',
    'CenturyFactures',
    'CenturyLibri',
    'CenturyRdV',
    'CenturySystemMdc',
];
//# sourceMappingURL=century-objects.js.map